import Header1 from "./Component/Header1";
import "./App.css";
import Header2 from "./Component/Header2";
import PicsForm from "./Component/PicsForm";
import About from "./Component/About";
import TourEvents from "./Component/TourEvents";
import TourEvents2 from "./Component/TourEvents2";
import SpecialOffers from "./Component/SpecialOffers";
import NewTravel from "./Component/NewTravel";
import Client from "./Component/Client";
import NewsLetter from "./Component/NewsLetter";
import TourEvents3 from "./Component/TourEvents3";
import Footer from "./Component/Footer";



function App() {
  return (
    <div className="w-100">

<Header1  number="+923298064264" />
<Header2/>

<PicsForm/>
<div id="part2">
<About/>
<TourEvents/>
<TourEvents2/>
<SpecialOffers/>
<NewTravel/>
<Client/>
<NewsLetter/>
<TourEvents3/>
<Footer/>




</div>

    </div>
  );
}

export default App;
